import React from 'react';
import { clientGroups } from '../../data/clients';
export function Clients() {
  return <section aria-labelledby="clients-title" className="border-y border-line bg-stone py-20 lg:py-24" data-id="element-56" data-mp="3efu8b69j1x42">
      <div className="mx-auto grid max-w-site gap-12 px-6 lg:grid-cols-12 lg:px-10" data-id="element-57" data-mp="3ae8zpx4104zo">
        <div className="lg:col-span-4" data-id="element-58" data-mp="35fxr1ppgw0j1">
          <h2 id="clients-title" className="font-serif text-3xl leading-tight tracking-tight text-ink lg:text-4xl" data-id="element-59" data-mp="35gyyzlb6s6wj">
            Au service des acteurs publics de l’habitat
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-muted" data-id="element-60" data-mp="200exb7qwii2">
            Indépendant de tout opérateur, le cabinet intervient exclusivement pour le compte de maîtres
            d’ouvrage publics et parapublics.
          </p>
        </div>

        <dl className="grid gap-x-10 sm:grid-cols-2 lg:col-span-7 lg:col-start-6" data-id="element-61" data-mp="3o8jfhoy1ootl">
          {clientGroups.map(group => <div key={group.label} className="border-t border-ink/20 py-6" data-id="element-62" data-mp="2cqh1czt8exqi">
              <dt className="font-serif text-xl text-ink" data-id="element-63" data-mp="mrks814lbqai">{group.label}</dt>
              <dd className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-64" data-mp="msc9s81crnhs">{group.examples}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}